import { Reveal } from "./Reveal";
import { GraduationCap, ShieldCheck, FileCheck2, HeartPulse, Users } from "lucide-react";

const BADGES = [
  { icon: GraduationCap, label: "Trained & certified staff" },
  { icon: FileCheck2, label: "KYC verified professionals" },
  { icon: ShieldCheck, label: "Police verified professionals" },
  { icon: HeartPulse, label: "24/7 healthcare support" },
  { icon: Users, label: "500+ happy families" },
];

export const TrustBadges = () => (
  <section data-testid="trust-badges" className="py-16 lg:py-20 bg-brand-cream border-b border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
        {BADGES.map((b, i) => {
          const Icon = b.icon;
          return (
            <Reveal key={b.label} delay={i * 0.08}>
              <div data-testid={`badge-${i}`} className="flex flex-col items-center text-center gap-3">
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white border border-border shadow-sm">
                  <Icon size={24} className="text-brand" />
                </span>
                <p className="text-sm font-semibold text-brand-ink leading-snug max-w-[8.5rem]">
                  {b.label}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
